/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Proof_Ac_LabelInputs */

const en_dr_proof_ac_label = /** @type {(inputs: Dr_Proof_Ac_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AC-3`)
};

const id_dr_proof_ac_label = /** @type {(inputs: Dr_Proof_Ac_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AC-3`)
};

/**
* | output |
* | --- |
* | "AC-3" |
*
* @param {Dr_Proof_Ac_LabelInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_proof_ac_label = /** @type {((inputs?: Dr_Proof_Ac_LabelInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Proof_Ac_LabelInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_proof_ac_label(inputs)
	return en_dr_proof_ac_label(inputs)
});